<script setup>
import { useWebSiteStore } from '@/stores/web-site.store'

const webSiteStore = useWebSiteStore()

const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  documentRowType: {
    type: Number,
    default: null,
  },
  allowedRowTypes: {
    type: Array,
    default: null,
  }
})

const restrictedTypes = [webSiteStore.documentRowTypesEnum.EXPENSE, webSiteStore.documentRowTypesEnum.SERVICE, webSiteStore.documentRowTypesEnum.LABOR]
const documentRowTypeButtons = webSiteStore.hasClaim(webSiteStore.claimsEnum.REGISTRY_PRODUCT_WRITE) ? webSiteStore.documentRowTypeButtons : webSiteStore.documentRowTypeButtons.filter(btn => !restrictedTypes.includes(btn.type))
const filteredDocumentRowTypeButtons = props.allowedRowTypes ? documentRowTypeButtons.filter(btn => props.allowedRowTypes.includes(btn.type)) : documentRowTypeButtons

const emit = defineEmits(['valueChanged'])
</script>

<template>
  <div
    class="dx-form-group-caption"
    style="display: flex; align-items: center; justify-content: space-between; width: 100%;"
  >
    <div class="dx-form-group-caption-wrapper">
      <q-icon
        :name="props.data.name"
        class="dx-form-group-caption-icon"
      />
      <span class="dx-form-group-caption-text">
        {{ props.data.caption }}
      </span>
    </div>
    <div>
      <q-btn
        v-for="btn in filteredDocumentRowTypeButtons"
        :key="btn.type"
        :icon="btn.icon"
        flat
        size="sm"
        round
        :disabled="props.disabled"
        :class="{ 'bg-primary text-white': documentRowType === btn.type }"
        @click="emit('valueChanged', { value: btn.type })"
      />
    </div>
  </div>
</template>
